import api from './index';

export const adminService = {
  getAnalytics: async () => {
    const response = await api.get('/dashboard-analytics');
    return response.data;
  },
  
  getSystemHealth: async () => {
    const response = await api.get('/systemhealth');
    return response.data;
  }
};
